
/* OMAT JS-FUNKTIOT - LISÄTTY 16042024 */







document.addEventListener('DOMContentLoaded', function() {
  
    const cartIconContainer = document.querySelector('.header-tools-cart-icon');
    if (!cartIconContainer) {
        console.error("Ostoskori-ikonia ei löydy.");
        return;
    }

    let cartCount = document.querySelector('#cart-count');
    if (!cartCount) {
        cartCount = document.createElement('span');
        cartCount.id = 'cart-count';
        //cartIconContainer.appendChild(cartCount);
    }

    //updateCartCount();

    document.querySelectorAll('form[id^="AddToCartForm-"]').forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            var formData = new FormData(this);
            var productTitle = form.querySelector('.product-title') ? form.querySelector('.product-title').textContent : "Tuote";

            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                console.log('Tuote lisätty:', data);
                displaySuccessMessage(this, productTitle);
                toggleCartIndicator(true); // Aseta indikaattori näkyväksi
                //updateCartCount(); // Päivitä ostoskorin määrä
                //hideCartIndicator(); // Piilota indikaattori
            })
            .catch(error => {
                console.error('Virhe lisättäessä tuotetta ostoskoriin:', error);
            });
        });
    });

function displaySuccessMessage(button, productTitle) {
    const detailsElement = button.closest('.product-list-item').querySelector('.product-list-item-details');
    if (detailsElement) {
        const messageIdentifier = `message-for-${productTitle.replace(/[^a-zA-Z0-9]/g, '-')}`;
        let existingMessage = detailsElement.querySelector('.' + messageIdentifier);

        if (!existingMessage) {
            const messageHTML = `<div class="product-message success-message oma ${messageIdentifier} fade-in">${productTitle} on onnistuneesti lisätty <a href="/cart">ostoskoriin</a>.</br>Voit joko jatkaa ostoksia tai <button class="product-message__checkout-button" type="submit" name="checkout" form="checkout_form">siirtyä kassalle</button>.</div>`;
            detailsElement.insertAdjacentHTML('beforeend', messageHTML);
            // Asetetaan viive ennen kuin 'visible' luokka lisätään, jotta fade-in efekti toimii
            setTimeout(() => {
                detailsElement.lastElementChild.classList.add('visible');
            }, 5); // Viive 10 millisekuntia on yleensä riittävä
        } else {
            console.log("Viesti on jo näytetty, ei lisätä uudelleen");
        }
    } else {
        console.error('Tuotteen yksityiskohtia ei löytynyt, viestiä ei voida näyttää.');
    }
}



function toggleCartIndicator(show) {
    var cartIcon = document.querySelector('.header-tools-cart-icon');
    if (cartIcon) {
        // Tarkistetaan, onko 'cart-has-content' luokka jo lisätty
        var hasContent = cartIcon.classList.contains('cart-has-content');
        if (show && !hasContent) {
            cartIcon.classList.add('cart-has-content');
            // Luodaan CSS-indikaattori, jos sitä ei ole vielä olemassa
            var existingDot = cartIcon.querySelector('.cart-contents-dot');
            if (!existingDot) {
                var dot = document.createElement('span');
                dot.className = 'cart-contents-dot';
                dot.style.cssText = 'animation: pop-in 0.3s ease-out forwards; position: absolute; top: -3px; right: -4px; width: 13px; height: 13px; border: 2px solid #ffffff; background: #262e79; border-radius: 50%; content: "";';
                cartIcon.appendChild(dot);
            }
        } else if (!show && hasContent) {
            cartIcon.classList.remove('cart-has-content');
            // Poistetaan indikaattori, jos se on olemassa
            var existingDot = cartIcon.querySelector('.cart-contents-dot');
            if (existingDot) {
                cartIcon.removeChild(existingDot);
            }
        }
    }
}




/*
function toggleCartIndicator(show) {
    var cartIcon = document.querySelector('.header-tools-cart-icon');
    if (cartIcon) {
        // Kun 'show' on true, lisätään luokat, jos niitä ei vielä ole
        if (show) {
            if (!cartIcon.classList.contains('cart-has-content')) {
                cartIcon.classList.add('cart-has-content');
            }
            if (!cartIcon.classList.contains('cart-contents-dot')) {
                cartIcon.classList.add('cart-contents-dot');
            }
        } else {
            // Jos 'show' on false, poistetaan luokat
            cartIcon.classList.remove('cart-has-content', 'cart-contents-dot');
        }
    }
}
*/



    function updateCartCount() {
        fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            if (data.item_count > 0) {
                cartCount.textContent = data.item_count;
                cartCount.style.display = 'block';
            } else {
                cartCount.style.display = 'none';
            }
        })
        .catch(error => console.error('Virhe haettaessa ostoskorin tietoja:', error));
    }

    function hideCartIndicator() {
        var cartIcon = document.querySelector('.header-tools-cart-icon');
        if (cartIcon) {
            cartIcon.classList.add('hide-indicator');
        }
    }
});

